import React from 'react'
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/accordion'
import { Box, Flex, Link, VStack, Text as ChakraText } from '@chakra-ui/layout'
import { Switch } from '@chakra-ui/switch'
import type { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'
import { SettingsToggleBox } from '..'
import type { SettingsResponse } from '../../../interfaces'
import PermissionGuard from '../../PermissionGuard'
import { PermissionsEnum } from '../../../../utils'
import { MdCrop } from 'react-icons/md'

const VideoSettingsAdvanced = ({
  values,
  handleChange,
}: FormikProps<SettingsResponse>): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PermissionsEnum.SELF_IMAGE_SETTINGS_MANAGE}>
      {(hasPermission: boolean) => (
        <AccordionItem>
          <AccordionButton px={12} py={8}>
            <Flex
              flex="1"
              textAlign="left"
              lineHeight="1.5em"
              fontWeight="700"
              gap="1em"
            >
              <MdCrop fontSize="1.5em" />
              {t('video_advanced', 'Advanced')}
            </Flex>
            <Box
              background="appPaleGreyThree"
              borderRadius="50%"
              padding="0.25em"
            >
              <AccordionIcon color="appSlate" display="block" />
            </Box>
          </AccordionButton>
          <AccordionPanel px={12} py={8} position="relative">
            <VStack spacing="0.75em">
              <SettingsToggleBox>
                <Flex justifyContent="space-between" width="100%">
                  <ChakraText fontWeight="700">
                    {t(
                      'crop_at_max_as_crop_at_max_enlarge',
                      'Allow upscaling with c-at_max',
                    )}
                  </ChakraText>
                  <Switch
                    name="videoSettings.transformation.cropAtMaxAsCropAtMaxEnlarge"
                    isDisabled={!hasPermission}
                    isChecked={
                      values.videoSettings.transformation
                        .cropAtMaxAsCropAtMaxEnlarge
                    }
                    onChange={handleChange}
                  />
                </Flex>
                <ChakraText>
                  {t(
                    'crop_at_max_as_crop_at_max_enlarge_description',
                    "When enabled, 'c-at_max' behaves like 'c-at_max_enlarge', allowing videos to upscale beyond their original size while preserving aspect ratio. If disabled, videos will not be enlarged beyond their original dimensions.",
                  )}{' '}
                  <Link
                    isExternal
                    href="https://imagekit.io/docs/video-resize-and-crop#max-size-cropping-strategy---c-at_max"
                  >
                    {t('read_more', 'Read More')}
                  </Link>
                </ChakraText>
              </SettingsToggleBox>
            </VStack>
          </AccordionPanel>
        </AccordionItem>
      )}
    </PermissionGuard>
  )
}

export default VideoSettingsAdvanced
